const animations = [
    {
        selector: '[data-load-animation]',
        path: { dirname: 'animations', filename: 'loadAnimation' },
    },
];

const preventLoadingAnimations = [
    {
        selector: '[data-load-animation]',
        path: { dirname: 'animations', filename: 'preventLoadingAnimations' },
    },
];

const animateLottieElements = [
    {
        selector: '[data-lottie-src]',
        path: { dirname: 'animations', filename: 'animateLottieElements' },
    },
];

export { animations, preventLoadingAnimations, animateLottieElements };
